<template>
	<b-modal ref="mdlRsaPazienteRiepilogoOperatoriAttivitaListModalComponent" size="xl" style="height: 100%" no-close-on-backdrop title="" dialog-class="sa-modal-full-height">
		<template #modal-title>Riepilogo Attivita</template>
		<div class="sa-list-component" style="padding-bottom: 20px">
			<div class="sa-list-component-header">
				<div class="sa-page-search-component">
					<b-form style="width: 100%" @submit.prevent="onSubmit">
						<!--
                        <b-row class="sa-form-btn-filter">
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Cognome</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroRiepilogoAttivita.cognomePaziente" placeholder="Inserisci un cognome.." />
                                    <button class="sa-page-search-component-btn-search" title="Cognome Paziente">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </div>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Nome</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroRiepilogoAttivita.nomePaziente" placeholder="Inserisci un nome.." />
                                    <button class="sa-page-search-component-btn-search" title="Nome Paziente">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </div>
                            </b-col>
                        </b-row>
                        -->
						<b-row class="sa-form-btn-filter">
							<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
								<label class="sa-label-data">Data Prevista dal:</label>
								<div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
									<date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" v-model="filtroRiepilogoAttivita.dataPrevistaDal" placeholder="Data prevista dal.." />
									<button class="sa-page-search-component-btn-search" title="Data Prevista">
										<i class="fas fa-search"></i>
									</button>
								</div>
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
								<label class="sa-label-data">Data Prevista al:</label>
								<div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
									<date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" v-model="filtroRiepilogoAttivita.dataPrevistaAl" placeholder="Data prevista al.." />
									<button class="sa-page-search-component-btn-search" title="Data Prevista">
										<i class="fas fa-search"></i>
									</button>
								</div>
							</b-col>

							<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="tipoTab === 'STORICO'">
								<label class="sa-label-data">Data Effettuata dal:</label>
								<div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
									<date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" v-model="filtroRiepilogoAttivita.dataEffettuataDal" placeholder="Data effettuata dal.." />
									<button class="sa-page-search-component-btn-search" title="Data Effettuata">
										<i class="fas fa-search"></i>
									</button>
								</div>
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="tipoTab === 'STORICO'">
								<label class="sa-label-data">Data Effettuata al:</label>
								<div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
									<date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" v-model="filtroRiepilogoAttivita.dataEffettuataAl" placeholder="Data effettuata al.." />
									<button class="sa-page-search-component-btn-search" title="Data Effettuata">
										<i class="fas fa-search"></i>
									</button>
								</div>
							</b-col>
						</b-row>
					</b-form>
				</div>
			</div>
			<b-tabs v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onChangeTab">
				<b-tab title="Programmate" active>
					<b-table sticky-header stacked="lg" striped hover :items="itemsAttivita" :fields="fieldsAttivita" sort-icon-left head-variant="light" class="sa-b-table">
						<template #cell(index)="row">
							<span> {{ (page - 1) * perPage + row.index + 1 }} </span>
						</template>
						<template v-slot:cell(paziente)="{ item }">
							<span> {{ item.nome }} {{ item.cognome }} </span>
						</template>
						<template v-slot:cell(dataPrevista)="{ item }">
							<span>{{ formatDate(item.dataOraPrevista) }}</span>
						</template>
						<template v-slot:cell(dataEffettuata)="{ item }">
							<span>{{ formatDate(item.dataOraEffettuata) }}</span>
						</template>
					</b-table>
				</b-tab>
				<b-tab title="Storico">
					<b-table sticky-header stacked="lg" striped hover :items="itemsAttivita" :fields="fieldsAttivita" sort-icon-left head-variant="light" class="sa-b-table">
						<template #cell(index)="row">
							<span> {{ (page - 1) * perPage + row.index + 1 }} </span>
						</template>
						<template v-slot:cell(paziente)="{ item }">
							<span> {{ item.nome }} {{ item.cognome }} </span>
						</template>
						<template v-slot:cell(indicazioni)="{ item }">
							<span v-html="item.indicazioni"> </span>
						</template>
						<template v-slot:cell(dataPrevista)="{ item }">
							<span>{{ formatDate(item.dataOraPrevista) }}</span>
						</template>
						<template v-slot:cell(dataEffettuata)="{ item }">
							<span>{{ formatDate(item.dataOraEffettuata) }}</span>
						</template>
					</b-table>
				</b-tab>
			</b-tabs>
			<div class="sa-list-component-footer">
				<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
					<b-col lg="3">
						<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
					</b-col>
					<b-col lg="9">
						<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
					</b-col>
				</b-row>
			</div>
		</div>
	</b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
	components: { DatePicker },
	mixins: [UtilityMixin],
	data() {
		return {
			perPage: 50,
			currentPage: 1,
			activeTabIndex: 0,
			listKey: 0,
			page: 1,
			rows: 0,
			itemsAttivita: [],
			fieldsAttivita: [
				{
					label: "",
					key: "index",
					thStyle: "width: 4rem",
				},
				{ label: "Paziente", key: "paziente" },
				{ label: "Nome Attività", key: "nomeAttivita" },
				{ label: "Indicazioni", key: "indicazioni" },
				{ label: "Note", key: "note" },
				{
					label: "Data Prevista",
					key: "dataPrevista",
				},
				{
					label: "Data Effettuata",
					key: "dataEffettuata",
				},
			],
			pathResourceAttivita: "/rsaattivitapazienti",
			filtroRiepilogoAttivita: { nome: null, cognome: null, tipo: null, username: null, dataPrevistaDal: null, dataPrevistaAl: null, dataEffettuataDal: null, dataEffettuataAl: null },
			rigaSelezionata: null,
			tipoTab: "PROGRAMMATE",
		};
	},
	mounted() {
		let me = this;
		if (sessionStorage["filtroRiepilogoAttivita"]) {
			me.filtroRiepilogoAttivita = JSON.parse(sessionStorage["filtroRiepilogoAttivita"]);
		}
	},
	methods: {
		init(row) {
			let me = this;
			me.visibleFields = me.fields;
			me.$refs.mdlRsaPazienteRiepilogoOperatoriAttivitaListModalComponent.show();
			me.rigaSelezionata = row.item;
			me.loadAttivitaAttive();
		},
		onChangeTab(index) {
			this.tipoTab = index === 0 ? "PROGRAMMATE" : "STORICO";
			this.filtroRiepilogoAttivita = { nome: null, cognome: null, tipo: null, username: null, dataPrevistaDal: null, dataPrevistaAl: null, dataEffettuataDal: null, dataEffettuataAl: null };
			switch (index) {
				case 0:
					this.loadAttivitaAttive();
					break;

				case 1:
					this.loadAttivitaStorico();
					break;
				default:
					break;
			}
		},
		loadAttivitaStorico() {
			let me = this;
			me.itemsAttivita = [];
			me.filtroRiepilogoAttivita.perPage = me.perPage;
			me.filtroRiepilogoAttivita.page = me.currentPage;
			me.filtroRiepilogoAttivita.createUser = me.rigaSelezionata.username;
			me.filtroRiepilogoAttivita.tipoTab = "STORICO";
			UtilityMixin.methods.loadDataResources(me.pathResourceAttivita + "/operatore", me.filtroRiepilogoAttivita, me.loadAttivitaStoricoSuccess, me.loadAttivitaStoricoError);
		},
		loadAttivitaStoricoSuccess(response) {
			let me = this;
			me.itemsAttivita = response.data.data.list;
		},
		loadAttivitaStoricoError(response) {
			console.log("errore response", response);
		},
		onSubmit() {
			let me = this;
			me.$emit("onBeforeLoadData", true);
			let sessionStorage = window.sessionStorage;
			sessionStorage["filtroRiepilogoAttivita"] = JSON.stringify(me.filtroRiepilogoAttivita);
			if (me.tipoTab === "PROGRAMMATE") {
				this.loadAttivitaAttive();
			} else {
				this.loadAttivitaStorico();
			}
		},
		loadAttivitaAttive() {
			let me = this;
			me.itemsAttivita = [];

			me.filtroRiepilogoAttivita.perPage = me.perPage;
			me.filtroRiepilogoAttivita.page = me.currentPage;
			me.filtroRiepilogoAttivita.createUser = me.rigaSelezionata.username;
			me.filtroRiepilogoAttivita.tipoTab = "PROGRAMMATE";
			UtilityMixin.methods.loadDataResources(me.pathResourceAttivita + "/operatore", me.filtroRiepilogoAttivita, me.loadAttivitaAttiveSuccess, me.loadAttivitaAttiveError);
		},
		loadAttivitaAttiveSuccess(response) {
			let me = this;
			me.itemsAttivita = response.data.data.list;
			me.rows = response.data.data.list.length;
		},
		loadAttivitaAttiveError(response) {
			console.log("errore response", response);
		},
	},
};
</script>
<style scoped>
.sa-date-like-input,
.sa-date-like-input .mx-datepicker,
.sa-date-like-input .mx-input-wrapper {
	width: 100% !important;
}

.sa-date-like-input .mx-input {
	background: transparent !important;
}

.sa-date-like-input .mx-icon-calendar,
.sa-date-like-input .mx-icon-clear {
	display: none !important;
}

.sa-date-like-input .mx-input {
	padding-right: 10px !important;
}

.sa-b-table thead th,
.sa-b-table tbody td {
	padding-left: 0.75rem !important;
	padding-right: 0.75rem !important;
	vertical-align: middle !important;
	white-space: nowrap;
}

.sa-b-table table {
	table-layout: fixed;
	width: 100%;
}

.sa-b-table .text-center {
	text-align: center !important;
}
</style>
